/**
 * クラス名：アプリの初期起動画面
 * 説明：最初に起動するファイルであり、ルーティングページを指定する。
 * 作成者：ナンス
 * 作成日：2023/03/01
 * バージョン：1.0
 */
import './App.css';
import React, { forwardRef, useEffect } from 'react';
import { BrowserRouter as Router, Route, Redirect, Routes, Navigate, useParams } from 'react-router-dom';
import { StatusCodes } from 'http-status-codes';

import Login from './views/Login';
import MainLayout from './components/MainLayout';
import { updateAccessToken } from '../src/views/common/Common';
import { loginPath, getCurrentUserInfo } from '../src/views/common/CommonAPI';
import { ErrorMessage } from '../src/views/common/Message';
import ChangePassword from './views/ChangePassword';

const MainLayoutRoutes = ['/home/*', '/:customer/*', '/:parentList/*'];

class App extends React.Component {
  constructor(props) {
    super(props);
  }
  componentDidMount() {
    console.log('App起動---');
    window.addEventListener('message', (event) => {
      const { webEstAccessToken, webEstLoginUser, redirectUrl, targetSys, webEstId } = event.data;
      console.log('message listener ---', targetSys);
      if (targetSys === 'BP') {
        if (webEstAccessToken) {
          localStorage.setItem('iQxWeb_AccessToken', webEstAccessToken);
          localStorage.setItem('iQxWeb_LoginUser', encodeURI(JSON.stringify(webEstLoginUser)));
          // 親部品リストに遷移された場合、親部品リストに表示させたいID（BPから渡されたWebEstID）を渡す。
          if (redirectUrl.includes('home/:parentList') && webEstId) {
            const params = new URLSearchParams({
              webEstId: webEstId,
            });
            window.location.href = `${redirectUrl}?${params.toString()}`;
          } else if (redirectUrl.includes('home/:common.coefficient')) {
            window.location.href = redirectUrl;
          }
        }
      }
    });
    // Activate the event listener
    this.setupBeforeUnloadListener();
    this.setupKeydownListener();
  }

  componentWillUnmount() {
    window.removeEventListener('message', this.messageHandler);
  }

  // Browser閉じるの場合、ログイン情報を削除
  doSomethingBeforeUnload = () => {
    if (localStorage.getItem('iQxWeb_AccessToken') === null) {
      localStorage?.removeItem('iQxWeb_LoginUser');
      localStorage?.removeItem('iQxWeb_cur_pmx');
    }
    // localStorage?.removeItem('iQxWeb_LoginUser');
    // localStorage?.removeItem('iQxWeb_AccessToken');
    return '';
  };

  // Browser閉じるイベント
  setupBeforeUnloadListener = () => {
    window.addEventListener('beforeunload', (ev) => {
      return this.doSomethingBeforeUnload();
    });
  };

  setupKeydownListener = () => {
    document.addEventListener('keydown', this.handleKeydown);
  };

  handleKeydown = (e) => {
    // Check if the pressed key is F5
    if (e.key === 'F5') {
      e.preventDefault();
    }
  };
  render() {
    return (
      <Router>
        <Routes basename="iqx.webestimate">
          {/* ログイン */}
          <Route key="login" path="/login" element={<Login />} />
          {MainLayoutRoutes?.map((path, index) => (
            <Route key={index} path={path} element={<MainLayout />} />
          ))}
          <Route key="login2" path="*" element={<Navigate to="/login" replace />} />
          <Route key="changePassword" path="/changePassword" element={<ChangePassword />} />
        </Routes>
      </Router>
    );
  }
}

export default App;
